(function () {
  'use strict';

  // ---- Config
  const RATE_URL = 'https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=eur';
  const CACHE_KEY = 'BTC_EUR_RATE';
  const CACHE_TS_KEY = 'BTC_EUR_RATE_TS';
  const CACHE_TTL_SECONDS = 300; // 5 min
  const REFRESH_MS = 60 * 1000;  // periodic soft refresh

  // ---- Utils
  function log(...args) { /* console.debug('[BTC]', ...args); */ }
  function safe(fn, fallback) {
    try { return fn(); } catch (e) { console.warn('[BTC]', e); return fallback; }
  }
  function debounce(fn, ms) {
    let t = null;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  async function getBtcEurRate() {
    try {
      const now = Math.floor(Date.now() / 1000);
      const cached = sessionStorage.getItem(CACHE_KEY);
      const cachedTs = Number(sessionStorage.getItem(CACHE_TS_KEY) || 0);
      if (cached && cachedTs && now - cachedTs < CACHE_TTL_SECONDS) {
        return Number(cached);
      }

      const ctrl = new AbortController();
      const timeout = setTimeout(() => ctrl.abort(), 8000); // 8s network timeout
      const res = await fetch(RATE_URL, { headers: { accept: 'application/json' }, signal: ctrl.signal });
      clearTimeout(timeout);

      if (!res.ok) throw new Error('Rate fetch failed: ' + res.status);
      const data = await res.json();
      const rate = Number(data?.bitcoin?.eur);
      if (!rate || !isFinite(rate)) throw new Error('Invalid BTC/EUR');
      sessionStorage.setItem(CACHE_KEY, String(rate));
      sessionStorage.setItem(CACHE_TS_KEY, String(now));
      return rate;
    } catch (e) {
      console.warn('[BTC] rate error:', e);
      // fall back to cached even if TTL expired
      const fallback = sessionStorage.getItem(CACHE_KEY);
      return fallback ? Number(fallback) : null;
    }
  }

  function eurFromContainer(container) {
    // Prefer exact cents (Shopify variant price in cents)
    const centsAttr = container.getAttribute('data-price-cents');
    if (centsAttr && /^\d+$/.test(centsAttr)) {
      return Number(centsAttr) / 100;
    }
    // Fallback: parse visible text
    const priceEl = container.querySelector('.price');
    if (!priceEl) return null;
    const txt = priceEl.textContent || '';
    let s = txt.replace(/[^\d.,]/g, '').trim();
    if (!s) return null;
    if (s.includes('.') && s.includes(',')) s = s.replace(/\./g, '').replace(',', '.');
    else if (s.includes(',')) s = s.replace(',', '.');
    const n = Number(s);
    return isFinite(n) ? n : null;
  }

  function formatBtc(x) { return x.toFixed(8); }

  async function updateOne(btcLineEl) {
    try {
      const container = btcLineEl.closest('[ref="priceContainer"]');
      if (!container) return;
      const eurAmount = eurFromContainer(container);
      if (eurAmount == null) return;

      const rate = await getBtcEurRate();
      if (!rate) return;

      const btc = eurAmount / rate;
      const span = btcLineEl.querySelector('[data-btc-value]');
      if (span) span.textContent = formatBtc(btc);
    } catch (e) {
      console.warn('[BTC] updateOne error:', e);
    }
  }

  async function updateAll() {
    const nodes = document.querySelectorAll('[data-btc-for-price]');
    for (const el of nodes) {
      // Avoid layout thrash by awaiting sequentially (cheap anyway)
      // eslint-disable-next-line no-await-in-loop
      await updateOne(el);
    }
  }

  const debouncedUpdateAll = debounce(updateAll, 50);

  function attachObservers() {
    // Observe only the exact price text elements, not the whole container (prevents loops)
    document.querySelectorAll('[ref="priceContainer"]').forEach((container) => {
      const priceEl = container.querySelector('.price') || container;
      const obs = new MutationObserver(() => debouncedUpdateAll());
      obs.observe(priceEl, { childList: true, characterData: true, subtree: true });
      // Keep a reference to disconnect later if needed
      container.__btcObs__ = obs;
    });

    // Common theme events on variant changes or section reloads
    document.addEventListener('variant:change', debouncedUpdateAll);
    document.addEventListener('variant:changed', debouncedUpdateAll);
    document.addEventListener('shopify:section:load', debouncedUpdateAll);
    document.addEventListener('shopify:section:reorder', debouncedUpdateAll);
  }

  function safeInit() {
    safe(() => {
      updateAll();
      attachObservers();
      setInterval(debouncedUpdateAll, REFRESH_MS);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }
})();
